<script>
    export let item;

    const locale = localStorage.getItem('locale');

    function getDate(item){
        if (item.period !== undefined){
            const dateStart = new Date(item.period.start).toLocaleDateString(locale, {
                year: 'numeric'
            });
            const dateEnd = new Date(item.period.end).toLocaleDateString(locale, {
                year: 'numeric'
            });
            return dateStart + " - " + dateEnd;
        } else {
            const dateIssued = new Date(item.issued).toLocaleDateString(locale, {
                year: 'numeric'
            });
            return dateIssued;
        }
    }
</script>

<div class="bg-white">
    <div class="container mx-auto flex items-center p-6">
        <picture class="flex-inital pr-6">
            <source
                srcset="{item.logo.path}_110.heic"
                type="image/heic"
            />
            <source
                srcset="{item.logo.path}_110.avif"
                type="image/avif"
            />
            <source
                srcset="{item.logo.path}_110.webp"
                type="image/webp"
            />
            <img alt="{item.logo.name}" src="{item.logo.path}_110.png"/>
        </picture>
        <div class="flex-1">
            <p class="text-2xl">{item.title}</p>
            <p class="text-sm">{item.institute}</p>
            <p class="text-sm">{getDate(item)}</p>
        </div>
    </div>
</div>